/*
 * File: abbyCadabbyApi.ts
 * Project: rosita
 * -----
 * Last Modified: 03 Mar 2022 12:22:31 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { ApiMultipleResponse } from 'models/ApiModels';
import { SparingRequestTypes } from 'models/SparingRequestTypes';
import { ReduxState } from 'redux/store';

const baseUrl = process.env.REACT_APP_CALVIN_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_CALVIN;

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const divisionId = (api.getState() as ReduxState).app.acuityContext?.selectedCustomer.id;
  const isDiagnostic = typeof args !== 'string' && (args.url === '/diagnostics/version' || args.url === '/diagnostics/apiName');

  if (!divisionId && !isDiagnostic) {
    return {
      error: {
        status: 400,
        statusText: 'Bad Request',
        data: 'No division ID received'
      }
    };
  }
  const urlEnd = typeof args === 'string' ? args : args.url;
  const adjustedUrl = isDiagnostic ? args.url : `divisions/${divisionId}/${urlEnd}`;
  const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };

  return fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as ReduxState).app.accessToken;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('x-functions-key', functionsKey);

        if (api.endpoint === 'createAttachment') {
          //headers.set('Content-Type', 'multipart/form-data');
        } else {
          headers.set('Content-Type', 'application/json');
        }
      }

      return headers;
    }
  })(adjustedArgs, api, extraOptions);
};

export const sparingRequestConfigTypes = createApi({
  reducerPath: 'sparingRequestConfigTypesApi',
  baseQuery,
  tagTypes: ['Types', 'Type'],
  endpoints: (builder) => ({
    getSparingRequestConfigurationTypes: builder.query<ApiMultipleResponse<SparingRequestTypes>, void>({
      query: () => {
        return {
          url: `/sparingRequestConfiguration/sparingRequestTypes`
        };
      },
      providesTags: ['Types'],
      transformResponse: (response: ApiMultipleResponse<SparingRequestTypes>) => {
        return response;
      }
    }),
    getSparingRequestConfigurationType: builder.query<SparingRequestTypes, string>({
      query: (typeId) => {
        return {
          url: `/sparingRequestConfiguration/sparingRequestTypes/${typeId}`
        };
      },
      providesTags: ['Type'],
      transformResponse: (response: SparingRequestTypes) => {
        return response;
      }
    })
  })
});

export const { useGetSparingRequestConfigurationTypesQuery, useGetSparingRequestConfigurationTypeQuery } = sparingRequestConfigTypes;
